import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import {
  AccountAddRequest,
  AccountResponse,
  AccountUpdateRequest,
} from '@entities/account';
import { Observable } from 'rxjs';

type Role = 'system_admin' | 'tenant_admin' | 'tenant_user';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private api: ApiService) {}

  /**
   * アカウント一覧を取得する
   * @returns アカウント一覧
   */
  findAll(): Observable<AccountResponse[]> {
    const url = '/users';
    return this.api.get<AccountResponse[]>(url);
  }

  /**
   * アカウント一覧を追加する
   * @param request 追加内容
   */
  add(roleId: Role, request: AccountAddRequest): Observable<AccountResponse> {
    const url = `/users/${roleId}`;
    return this.api.post<AccountResponse>(url, request);
  }

  /**
   * アカウントを更新する
   * @param request 更新内容
   */
  update(
    role: Role,
    request: AccountUpdateRequest,
  ): Observable<AccountResponse> {
    const url = `/users/${role}/${request.userId}`;
    return this.api.put<AccountResponse>(url, request);
  }

  /**
   * アカウントを一括削除する
   * @param request ユーザーIDの一覧
   */
  delete(roleId: Role, request: string[]): Observable<void> {
    const url = `/users/${roleId}/_delete`;
    return this.api.post<void>(url, request);
  }

  /**
   * ログインを通知する。
   */
  postLoggedIn(): Observable<void> {
    const url = '/postlogin';
    return this.api.post<void>(url, {});
  }

  /**
   * ログインユーザーを取得する
   * @returns ログインユーザー
   */
  findLoggedInUser(): Observable<AccountResponse> {
    const url = '/me';
    return this.api.get<AccountResponse>(url);
  }

  /**
   * MFAステータスの有効化リクエストをする
   */
  enableMfa(): Observable<void> {
    const url = '/me/mfa';
    const request = {};
    return this.api.post<void>(url, request);
  }

  /**
   * MFAステータスの有効化リクエストをする
   */
  disableMfa(): Observable<void> {
    const url = '/me/mfa';
    return this.api.delete<void>(url);
  }
}
